<template>
  <div>
    <div @click="openChoose">
      <slot></slot>
    </div>
    <input type="file" :accept="accept" name="上传" ref="fileInputRef" @change="fileChoosed" style="display: none;" />
  </div>
</template>
<script>
import * as qiniu from 'qiniu-js'
import commonApi from '@/api/common'

export default {
  props: {
    accept: {
      type: String,
      default: '' // 默认不限制类型
    },
    maxSize: {
      type: Number,
      default: 20 // 默认最大20MB
    }
  },
  data() {
    return {
      subscription: null,
      bucketName: commonApi.commonUrl.qNBucketName2
    }
  },
  methods: {
    async fileChoosed(e) {
      const file = e.target.files[0]
      this.video = file
      const form = await this.uploadBefore(file)
      if (!form) {
        this.$emit('onFail')
        return
      }
      const putExtra = {
        fname: file.name,
        MimeType: this.accept
      }
      const observable = qiniu.upload(file, form.key, form.token, putExtra)
      if (this.subscription) {
        this.subscription.unsubscribe() // 已有上传内容，先取消上一次上传
      }
      this.subscription = observable.subscribe(
        this.uploadProgress, // next: 进度回调
        this.uploadError, // error：出错回调
        this.uploadSuccess // complete：成功回调
      ) // 上传开始
    },
    // 上传前
    async uploadBefore(file) {
      if (this.maxSize && file.size > this.maxSize * 1024 * 1024) {
        this.$message.warning(`文件大小超过${this.maxSize}MB`)
        return null
      }
      this.$emit('onBefore', file)
      let key = file.name
      return await this.getQNToken({
        bucketName: this.bucketName,
        fileName: key
      })
    },
    // 上传进度变化
    uploadProgress(res) {
      this.$emit('onProgress', {
        event: res
      })
    },
    // 上传成功
    uploadSuccess(res) {
      this.$emit('onSuccess', res)
      this.subscription = null
    },
    // 上传失败
    uploadError(err) {
      try {
        this.$message({
          showClose: true,
          type: 'error',
          message: err,
          duration: 0
        })
        this.$emit('onFail', {
          err: err
        })
        this.subscription = null
      } catch (e) {
        console.log(e)
      }
    },
    // 获取七牛云上传token
    getQNToken(req) {
      return new Promise((resolve, reject) => {
        commonApi.getQNUploadToken(req).then(res => {
          if (res.Success) {
            resolve(res.Data)
          } else {
            reject()
            this.$message.error(res.Msg)
          }
        })
      })
    },
    // 打开文件选择器
    openChoose() {
      const fileInput = this.$refs.fileInputRef
      fileInput.click()
    }
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/operateManage/wechat_push/fileUpload.vue